import React, { useEffect, useState } from 'react';
import { Row, Col, Input, Button } from 'reactstrap';
import FieldConfig from './FieldConfig';


const FilterInTable = (props) => {
  const { componentName } = props;

  const [filters, setFilters] = useState({});
  const [isDisabled, setIsDisabled] = useState(true);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleSearch = () => {
    console.log('Searching with filters:', filters);
  };

  const handleClear = () => {
    setFilters({});
  };

  useEffect(() => {
    const allFieldsEmpty = Object.values(filters).every(field => field === '' || field === undefined);
    setIsDisabled(allFieldsEmpty);
  }, [filters]);

  const renderFields = () => {
    const fields = FieldConfig[componentName] || [];
    return (
      <>
        {fields.length != 0 && (
          <Col>
            <Row className="g-0 row-gap-2">
              {fields.map(({ name, placeholder, type }) => (
                <Col xs={12} md={4} lg={3} xxl={2} className="mb-2 mb-md-0 pe-2" key={name}>
                  <Input
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    value={filters[name] || ''}
                    onChange={handleInputChange}
                  />
                </Col>
              ))}
            </Row>
          </Col>
        )}
      </>
    )
  };

  return (
    <div style={{ minHeight: '34px', backgroundColor: '#F2F2F2', padding: '1rem' }}>
      <Row className="d-flex align-items-center g-0 row-gap-2">
        <Col xxl={1} style={{ fontWeight: '600' }}>Filter by:</Col>
        {renderFields()}
        <Col xxl={2} className="d-flex justify-content-end align-items-center">
          <Button color="warning" onClick={handleSearch} disabled={isDisabled}>
            Search
          </Button>
          <div type='button' onClick={handleClear} className="text-decoration-none ps-4 ps-xxl-3" disabled={isDisabled}>
            Clear Filter
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default FilterInTable;